export default __webpack_public_path__ + "static/media/prod4.d18a127b.png";